export const RESERVA_PLACE_REQUEST = "RESERVA_PLACE_REQUEST";
export const RESERVA_PLACE_SUCCESS = "RESERVA_DELETE_SUCESS";
export const RESERVA_PLACE_FAIL = "RESERVA_DELETE_FAIL";

export const RESERVA_GET_RESULT_REQUEST = "RESERVA_GET_RESULT_REQUEST";
export const RESERVA_GET_RESULT_SUCCESS = "RESERVA_GET_RESULT_SUCCESS";
export const RESERVA_GET_RESULT_FAIL = "RESERVA_GET_RESULT_FAIL";

export const RESERVA_PLACE_RESET = "RESERVA_PLACE_RESET";
